import { create } from 'zustand';
const useTimeOutput = create(() => ({ time: undefined }));
const reactiveOutput = {
    useTime: () => {
        return useTimeOutput((s) => s.time);
    },
};
export class TimeServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setTime(time) {
        useTimeOutput.setState({ time });
    }
}
